export default function resolveDrawPerimeter({ mouseDown, mouseDrag }) {
    if (mouseDown === null || mouseDrag === null) {
        return null;
    }
    const width = mouseDrag.x - mouseDown.x;
    const height = mouseDrag.y - mouseDown.y;

    return {
        x: mouseDown.x + (width < 0 ? width : 0),
        y: mouseDown.y + (height < 0 ? height : 0),
        width: width < 0 ? -width : width,
        height: height < 0 ? -height : height,
    };
}
